import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _defineProperty from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _components;
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { payrollSubStaffList as _payrollSubStaffList, getListHeaderColumns } from '@/api/payroll';
// 上传
import Pagination from '@/components/pagination';
import allTable from './components/all-info';
import { info, common, NetPay } from './column.js';
import ExportExcelDialog from '@/components/ExportExcelDialog';
import SalaryStorageSettingDialog from './components/salary-storage-setting-dialog.vue';
import { mapState } from 'vuex';
export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: (_components = {
    allTable: allTable,
    Pagination: Pagination
  }, _defineProperty(_components, ExportExcelDialog.name, ExportExcelDialog), _defineProperty(_components, "SalaryStorageSettingDialog", SalaryStorageSettingDialog), _components),
  data: function data() {
    return {
      projectId: this.$route.params.id,
      showSalaryStorageSetting: false,
      subProjectInfo: {},
      isIndeterminate: false,
      checkAll: true,
      columnInfo: info,
      currentColumn: [],
      // 表头
      tableData: {},
      requestParams: {
        // 请求参数
        page_size: 20,
        page: 1,
        search_word: '',
        data_type: 'all' // tabs栏控制
      },

      page: {
        pageSizes: [20, 50, 100],
        total: 0,
        currentPage: 1
      },
      tableCloumns: []
    };
  },
  computed: _objectSpread({}, mapState({
    // 货币
    currency: function currency(state) {
      return state.user.company_info.currency;
    }
  })),
  filters: {
    ThousandSeparator: function ThousandSeparator(input) {
      return input && input.toString().replace(/(^|\s)\d+/g, function (m) {
        return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
      });
    }
  },
  created: function created() {
    this.init();
  },
  watch: {
    currentColumn: {
      handler: function handler(v) {
        var _this = this;
        // this.activeData.info.settlement_type 1月结 2日结 3其他 99其他
        this.tableCloumns = v.filter(function (item) {
          return item.isShow ? item.isShow.includes(Number(_this.activeData.info.settlement_type)) : true;
        });
      },
      deep: true,
      immediate: true
    },
    'activeData.state': {
      handler: function handler(v) {
        if (v === 3) {
          this.payrollSubStaffList();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    init: function init() {
      this.loadSubStaffColumns();
      this.payrollSubStaffList(); // 获取表格列表信息
    },
    // get_income_type_column() {
    //   const res = []
    //   if (+this.activeData?.info.tax_deduction_status === 4) {
    //     res.push({
    //       label: this.$t('1980'),
    //       prop: 'income_type',
    //       // 1月结 2日结
    //       isShow: [1, 2],
    //       align: 'left',
    //       width: '200px'
    //     })
    //   }
    //   return res
    // },
    loadSubStaffColumns: function loadSubStaffColumns() {
      var _this2 = this;
      this.currentColumn = [];
      getListHeaderColumns({
        sub_project_id: this.projectId
      }).then(function (res) {
        _this2.currentColumn = [].concat(_toConsumableArray(common), _toConsumableArray(res.data), _toConsumableArray(NetPay));
        _this2.currentColumn[0].width = '264';
        _this2.edit = true;
        if (_this2.currentColumn.length === 2) {
          _this2.currentColumn[0].width = 'auto';
        }
      });
    },
    payrollSubStaffList: function payrollSubStaffList() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var msg, res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 请求列表数据
              msg = _objectSpread(_objectSpread({
                sort: _this3.sort,
                // 排序相关
                dir: _this3.dir
              }, _this3.requestParams), {}, {
                sub_project_id: _this3.projectId
              });
              _context.next = 3;
              return _payrollSubStaffList(msg);
            case 3:
              res = _context.sent;
              data = res.data;
              _this3.tableData = res.data;
              _this3.page.total = data.count;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      // 排序
      this.sort = prop;
      this.dir = order;
      this.payrollSubStaffList();
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      // 选择展示表格内容
      var checkedCount = value.length;
      var len = Object.keys(this.columnInfo).length;
      this.checkAll = checkedCount === len;
      this.isIndeterminate = checkedCount > 0 && checkedCount < len;
      this.loadSubStaffColumns();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.requestParams.page = val;
      this.payrollSubStaffList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.requestParams.page = 1;
      this.requestParams.page_size = val;
      this.payrollSubStaffList();
    },
    handleExport: function handleExport() {
      var params = {
        relation_type: 3,
        relation_id: this.projectId
      };
      var data = {
        sub_project_id: this.projectId
      };
      this.$refs.ExportExcelDialog.init(params, data);
    },
    handleMoreClick: function handleMoreClick() {
      this.showSalaryStorageSetting = true;
    },
    handleSalaryStorageSaved: function handleSalaryStorageSaved() {
      // 保存叶子字段后刷新表头/数据展示
      this.loadSubStaffColumns();
      this.payrollSubStaffList();
    }
  }
};